import { Link } from 'react-router-dom';
import { featuredProducts } from '../../../mocks/featured-products';

export default function FeaturedProducts() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* 標題 */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            最新上架
          </h2>
          <p className="text-gray-600 text-lg">
            精選中國最新童裝款式，全店買一送一優惠中
          </p>
        </div>

        {/* 產品網格 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10">
          {featuredProducts.map((product) => (
            <Link
              key={product.id}
              to={`/product/${product.id}`}
              className="group bg-white rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
              data-product-shop
            >
              {/* 產品圖片 */}
              <div className="relative w-full h-80 overflow-hidden bg-gray-50">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                {product.badge && (
                  <div className="absolute top-3 left-3">
                    <span className="bg-red-600 text-white px-3 py-1 rounded-full text-sm font-medium whitespace-nowrap">
                      {product.badge}
                    </span>
                  </div>
                )}
                <div className="absolute top-3 right-3">
                  <button className="w-9 h-9 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-pink-600 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-heart-line text-lg"></i>
                  </button>
                </div>
              </div>

              {/* 產品信息 */}
              <div className="p-4">
                <div className="text-xs text-gray-500 mb-2">{product.category}</div>
                <h3 className="text-base font-medium text-gray-900 mb-3 line-clamp-2 group-hover:text-pink-600 transition-colors">
                  {product.name}
                </h3>
                <div className="flex items-center gap-2">
                  <span className="text-xl font-bold text-pink-600">
                    ${product.price}
                  </span>
                  <span className="text-sm text-gray-400 line-through">
                    ${product.originalPrice}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}